import React from 'react';
import Script from 'next/script';

const Termly = () => (
  <Script
    type="text/javascript"
    src="https://app.termly.io/resource-blocker/5df6ac85-ad21-468e-8290-e9aef132c2e7?autoBlock=on"
  />
);

export default Termly;
